import { render, staticRenderFns } from "./ClientsTab.vue?vue&type=template&id=426e4fb9&scoped=true"
import script from "./ClientsTab.vue?vue&type=script&lang=js"
export * from "./ClientsTab.vue?vue&type=script&lang=js"
import style0 from "./ClientsTab.vue?vue&type=style&index=0&id=426e4fb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e4fb9",
  null
  
)

export default component.exports